module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/events-calculator/events-calculator.component.css
// module id = ./src/app/components/calculator/calculator-item/events-calculator/events-calculator.component.css
// module chunks = main